<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "AppSidebarCart",
  props: ["active"],
  computed: {
    ...mapGetters(["cartCount", "cartTotal"]),
    ...mapState(["cart"]),
  },
  methods: {
    increment(item) {
      this.$store.commit("addOneToCart", item);
    },
    decrement(item) {
      this.$store.commit("removeOneFromCart", item);
    },
  },
};
</script>

<template>
  <div
    class="cart-background"
    :class="{ show: active }"
    @click="$emit('close-product-cart')"
  />
  <div class="cart" :class="{ show: active }">
    <div class="cart-Menu">
      <div class="Menu">
        <div class="cart-Bar">
          <div class="title">
            <h2>Shopping Cart</h2>
            <p v-if="cartCount">{{ cartCount }}</p>
          </div>
        </div>
        <div
          class="cart-Toggle"
          id="cart-menu"
          @click="$emit('close-product-cart')"
        >
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>
      </div>
      <hr />
      <div class="cart-Items" v-if="cartCount > 0">
        <div class="cart-Item" v-for="item in cart" :key="item.id">
          <div class="left">
            <div class="cart-image">
              <div class="wrapper-image">
                <img
                  :src="`/Products/${item.img}`"
                  :alt="item.img"
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>
          </div>
          <div class="right">
            <div class="name">{{ item.name }}</div>
            <div class="price">${{ item.price }}</div>
            <div class="count">
              <button class="button" @click="decrement(item)">-</button>
              <div class="number">{{ item.quantity }}</div>
              <button class="button" @click="increment(item)">+</button>
            </div>
          </div>
        </div>
        <section class="payment">
          <div class="total">
            <div class="caption">
              <p>
                <span>Subtotal:</span>
              </p>
              <p class="dark">Total:</p>
            </div>
            <div class="num">
              <p>
                <span>${{ cartTotal }}</span>
              </p>
              <p class="dark">${{ cartTotal }}</p>
            </div>
          </div>
        </section>
        <div style="display: flex">
          <button class="Cart">
            <router-link to="/cart">View Cart</router-link>
          </button>
        </div>
        <button class="button">
          <router-link to="/shop">Continue Shopping</router-link>
        </button>
      </div>
      <transition v-else>
        <div class="no-content">
          <div class="circle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32.402"
              height="32"
              viewBox="0 0 24 24"
              id="shopping-bag"
            >
              <path
                fill="#000000"
                d="M19.5,7H16V5.9169922c0-2.2091064-1.7908325-4-4-4s-4,1.7908936-4,4V7H4.5C4.4998169,7,4.4996338,7,4.4993896,7C4.2234497,7.0001831,3.9998169,7.223999,4,7.5V19c0.0018311,1.6561279,1.3438721,2.9981689,3,3h10c1.6561279-0.0018311,2.9981689-1.3438721,3-3V7.5c0-0.0001831,0-0.0003662,0-0.0006104C19.9998169,7.2234497,19.776001,6.9998169,19.5,7z M9,5.9169922c0-1.6568604,1.3431396-3,3-3s3,1.3431396,3,3V7H9V5.9169922z M19,19c-0.0014038,1.1040039-0.8959961,1.9985962-2,2H7c-1.1040039-0.0014038-1.9985962-0.8959961-2-2V8h3v2.5C8,10.776123,8.223877,11,8.5,11S9,10.776123,9,10.5V8h6v2.5c0,0.0001831,0,0.0003662,0,0.0005493C15.0001831,10.7765503,15.223999,11.0001831,15.5,11c0.0001831,0,0.0003662,0,0.0006104,0C15.7765503,10.9998169,16.0001831,10.776001,16,10.5V8h3V19z"
              ></path>
            </svg>
          </div>
          <p class="text">No products in the cart</p>
          <button>
            <router-link to="/shop">Continue Shopping</router-link>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scope>
.cart-background {
  background-color: rgba(124, 124, 124, 0.5);
  width: 100%;
  height: 100vh;
  right: 0;
  top: 0;
  z-index: 100;
  position: fixed;
  transition: display 0.5s;
  display: none;

  &.show {
    display: block;
  }
}

.cart {
  background-color: #fff;
  box-sizing: border-box;
  width: 350px;
  height: 100vh;
  right: -100%;
  top: 0;
  z-index: 101;
  border-radius: 5px;
  overflow-y: auto;
  padding: 10px 28px 0 28px;
  position: fixed;
  transition: 0.5s;
  box-shadow: 0 3.2px 2.2px rgba(0, 0, 0, 0.02),
    0 7px 5.4px rgba(0, 0, 0, 0.028), 0 12.1px 10.1px rgba(0, 0, 0, 0.035),
    0 19.8px 18.1px rgba(0, 0, 0, 0.042), 0 34.7px 33.8px rgba(0, 0, 0, 0.05),
    0 81px 81px rgba(0, 0, 0, 0.07);

  &.show {
    right: 0;
  }

  .Menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .cart-Bar {
      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;

        h2 {
          font-family: Poppins;
          text-transform: uppercase;
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          line-height: 21px;
          color: #000000;
        }
      }
    }

    .cart-Toggle {
      display: flex;
      position: relative;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        transform: scale(0.8);
      }

      .bar {
        height: 2px;
        background-color: #000;
        margin: 5px auto;
        border-radius: 4px;
      }

      .bar:nth-child(2) {
        display: none;
      }

      .bar:nth-child(1) {
        transform: translateX(5px) translateY(6px) rotate(45deg);
        -webkit-transform: translateX(5px) translateY(6px) rotate(45deg);
        -o-transform: translateX(5px) translateY(6px) rotate(45deg);
        -ms-transform: translateX(5px) translateY(6px) rotate(45deg);
        width: 20px;
        opacity: 0.6;
      }

      .bar:nth-child(3) {
        transform: translateX(5px) translateY(-6px) rotate(-45deg);
        -webkit-transform: translateX(5px) translateY(-6px) rotate(-45deg);
        -o-transform: translateX(5px) translateY(-6px) rotate(-45deg);
        -ms-transform: translateX(5px) translateY(-6px) rotate(-45deg);
        width: 20px;
        opacity: 0.6;
      }
    }
  }

  .cart-Items {
    margin: 0 auto;

    .cart-Item {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 1fr;
      padding: 20px 0;
      gap: 2rem;

      .left {
        img {
          display: block;
          width: 100%;
          border-radius: 10%;
          filter: drop-shadow(0 30px 20px rgba(0, 0, 0, 0.2));
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        .name {
          font-size: 14px;
          font-weight: bold;
          line-height: 1.5;
          margin-bottom: 10px;
          font-family: Popins;
        }

        .price {
          font-size: 20px;
          font-weight: bold;
          font-family: Montserrat;
        }

        .count {
          display: flex;
          align-items: center;

          .number {
            font-size: 14px;
            margin: 0 14px;
            width: 20px;
            text-align: center;
          }

          .button {
            cursor: pointer;
            width: 28px;
            height: 28px;
            border-radius: 100%;
            background-color: #eee;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: 0.2s;
            user-select: none;

            &:hover {
              background-color: #ddd;
            }
          }
        }
      }
    }

    .payment {
      padding: 20px 0;

      .total {
        display: grid;
        grid-template-columns: repeat(2, 1fr);

        .caption {
          width: 100%;
          font-family: Poppins;
          font-style: normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 21px;

          p:first-child {
            margin-bottom: 5px;
            height: 30px;
            align-items: center;
            display: flex;
          }

          .dark {
            background: rgba($color: #000000, $alpha: 0.09);
            height: 30px;
            align-items: center;
            display: flex;
          }
        }

        .num {
          width: 100%;
          font-family: Poppins;
          font-style: normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 21px;
          text-align: right;

          p:first-child {
            margin-bottom: 5px;
            height: 30px;
            align-items: center;
            display: flex;
            justify-content: flex-end;
            padding-right: 10px;
          }

          .dark {
            background: rgba($color: #000000, $alpha: 0.09);
            height: 30px;
            align-items: center;
            display: flex;
            justify-content: flex-end;
            padding-right: 10px;
          }
        }
      }
    }

    .Cart {
      margin: 0 auto;
      background: #000;
      width: 50%;
      border-radius: 4px;
      border: 1px solid #000000;
      padding: 10px 20px;
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #fff;
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      a {
        color: #fff;
        text-decoration: none;
      }
    }

    .button {
      border-radius: 4px;
      margin: 10px auto;
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      text-align: center;
      display: flex;
      text-align: center;
      justify-content: center;
      cursor: pointer;
      text-decoration: #000;
      transition: all 0.3s ease-in-out;

      a {
        color: #000;
        line-height: 30px;
      }
    }
  }

  .no-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 50% 0;
    gap: 10px;

    .circle {
      width: 80px;
      height: 80px;
      background: rgba($color: #000000, $alpha: 0.05);
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border-radius: 50%;

      svg {
        width: 50px;
        height: 50px;
        margin: 0 auto;
      }
    }

    .text {
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 21px;
      text-align: center;
      color: #000000;
    }

    button {
      background: #000;
      border-radius: 4px;
      border: 1px solid #000000;
      padding: 10px 20px;
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #fff;
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      a {
        color: #fff;
        text-decoration: none;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .cart {
    width: 350px;
    margin-top: auto;
  }
}
</style>
